module.exports = __webpack_public_path__ + "static/img/index_gx1.4769d25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_gx1.png
// module id = gOLl
// module chunks = 0